
import { createElement, useEffect, useState } from "react";
import React from "react";
import { map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { ThresholdLines, State__get_UnitValueToMs, ViewHelpers_mkColumnWith, ViewHelpers_mkRow, ViewHelpers_spaceN, State__get_UnitText, ViewHelpers_mkText, ViewHelpers_mkColumn, ViewHelpers_divWith, thresholdLineDefinitions, State__get_UnitValue } from "./PortWindCommon.js";
import { toList as toList_1, FSharpMap__get_Item, toSeq, ofList, tryFind } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { singleton as singleton_1, choose, ofArray, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { comparePrimitives, disposeSafe, getEnumerator, compare } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { ModalModule_view } from "../../Components/StenaWebUI/Modal/Modal.js";
import { singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { Color, theme } from "../../Theme.js";
import { printf, toText } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { ButtonBase_ViewPrimary, ButtonBase_ViewSecondary } from "../../Components/StenaWebUI/Elements/Button.js";
import { fromTryMethod } from "../Common.js";
import { tryParse } from "../../fable_modules/fable-library-js.5.0.0/Double.js";
import { FSharpRef } from "../../fable_modules/fable-library-js.5.0.0/Types.js";

export function thresholdModalView($props) {
    const state = $props.state;
    const onSave = $props.onSave;
    const onClose = $props.onClose;
    const isOpen = $props.isOpen;
    const getValue = (k) => defaultArg(map((v) => {
        const value = State__get_UnitValue(state)(v);
        return value.toString();
    }, tryFind(k, state.ThresholdLines.fields[0])), "");
    const thresholdStates = ofList(map_1((d) => [d.WeatherValueId, useState(getValue(d.WeatherValueId))], thresholdLineDefinitions), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    useEffect(() => {
        const enumerator = getEnumerator(toSeq(thresholdStates));
        try {
            while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                forLoopVar[1][1](getValue(forLoopVar[0]));
            }
        }
        finally {
            disposeSafe(enumerator);
        }
    }, [state.UnitsIsMetric]);
    return ModalModule_view(ofList(map_1((value_36) => value_36, ofArray([["isOpen", isOpen], ["headerText", "Threshold Lines Configuration"], ["width", "30vw"], ["onRequestClose", onClose], ["children", singleton_1(ViewHelpers_divWith([["style", {
        padding: 20 + "px",
    }]], toList(delay(() => append(map_1((d_1) => {
        let arg_2, tupledArg_1;
        return ViewHelpers_mkColumn(ofArray([ViewHelpers_mkText(theme(new Color(0, [])), 2, [], (arg_2 = State__get_UnitText(state), toText(printf("%s (%s)"))(d_1.ModalLabel)(arg_2))), (tupledArg_1 = FSharpMap__get_Item(thresholdStates, d_1.WeatherValueId), HtmlHelper_createElement("input", ofArray([["type", "number"], ["step", 0.1], ["value", tupledArg_1[0]], ["onChange", (ev_1) => {
            tupledArg_1[1](ev_1.target.value);
        }], ["style", {
            width: 95 + "%",
            padding: 8 + "px",
            marginTop: 8 + "px",
            marginBottom: 16 + "px",
            borderRadius: 4 + "px",
            borderWidth: 1,
            borderColor: theme(new Color(5, [])),
            backgroundColor: theme(new Color(5, [])),
            color: theme(new Color(4, [])),
            fontSize: 14 + "px",
        }]])))]));
    }, thresholdLineDefinitions), delay(() => append(ViewHelpers_spaceN(3), delay(() => {
        let p_1_2;
        return singleton(ViewHelpers_mkRow(singleton_1(ViewHelpers_mkColumnWith([["justifyContent", "flex-end"]], singleton_1(ViewHelpers_mkRow(ofArray([ButtonBase_ViewSecondary(ofList(map_1((value_34) => value_34, ofArray([["label", "Cancel"], ["onClick", (_arg_1) => {
            onClose();
        }]])), {
            Compare: (x_4, y_2) => (comparePrimitives(x_4, y_2) | 0),
        })), (p_1_2 = ofList(map_1((value_35) => value_35, ofArray([["label", "Save"], ["onClick", (_arg_2) => {
            onSave(new ThresholdLines(ofList(choose((tupledArg) => map((x_2) => [tupledArg[0], State__get_UnitValueToMs(state)(x_2)], fromTryMethod((arg) => {
                let outArg = 0;
                return [tryParse(arg, new FSharpRef(() => outArg, (v_2) => {
                    outArg = v_2;
                })), outArg];
            }, tupledArg[1][0])), toList_1(thresholdStates)), {
                Compare: (x_3, y_1) => (compare(x_3, y_1) | 0),
            })));
            onClose();
        }]])), {
            Compare: (x_5, y_3) => (comparePrimitives(x_5, y_3) | 0),
        }), createElement(ButtonBase_ViewPrimary, {
            p: p_1_2,
        }))])))))));
    }))))))))]])), {
        Compare: (x_6, y_4) => (comparePrimitives(x_6, y_4) | 0),
    }));
}

